import React, { useEffect, useState } from "react";
import QRCode from "qrcode.react";
import openSocket from "../../services/socket-io";
import toastError from "../../errors/toastError";

import { Dialog, DialogContent, Paper, Typography } from "@material-ui/core";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";

const QrcodeModal = ({ open, onClose, whatsAppId }) => {
	const [qrCode, setQrCode] = useState("");
	const [pairCode, setPairCode] = useState("");

	useEffect(() => {
		const fetchSession = async () => {
			if (!whatsAppId) return;

			try {
				const { data } = await api.get(`/whatsapp/${whatsAppId}`);
				console.log("QrcodeModal: Fetched session data", data);
				if (data.qrcode && data.qrcode.startsWith("PAIRCODE:")) {
					setPairCode(data.qrcode.split(":")[1]);
					setQrCode("");
				} else {
					setQrCode(data.qrcode);
					setPairCode("");
				}
			} catch (err) {
				toastError(err);
			}
		};
		fetchSession();
	}, [whatsAppId]);

	useEffect(() => {
		if (!whatsAppId) return;
		const socket = openSocket();

		socket.on("whatsappSession", data => {
			console.log("QrcodeModal: Received socket data", data);
			if (data.action === "update" && data.session.id === whatsAppId) {
				console.log("QrcodeModal: Updating state with", data.session);
				if (data.session.qrcode && data.session.qrcode.startsWith("PAIRCODE:")) {
					setPairCode(data.session.qrcode.split(":")[1]);
					setQrCode("");
				} else {
					setQrCode(data.session.qrcode);
					setPairCode("");
				}
			}

			if (data.action === "update" && data.session.qrcode === "" && !data.session.paircode) {
				onClose();
			}
		});

		return () => {
			socket.disconnect();
		};
	}, [whatsAppId, onClose]);

	return (
		<Dialog open={open} onClose={onClose} maxWidth="lg" scroll="paper">
			<DialogContent>
				<Paper elevation={0}>
					<Typography color="primary" gutterBottom>
						{pairCode ? i18n.t("qrCode.pairCodeMessage") : i18n.t("qrCode.message")}
					</Typography>
					{qrCode ? (
						qrCode.startsWith("data:image") ? (
							<div style={{ padding: "10px", background: "white", display: "inline-block" }}>
								<img src={qrCode} alt="QR Code" style={{ maxWidth: "250px", height: "auto" }} />
							</div>
						) : (
							<QRCode value={qrCode} size={256} />
						)
					) : pairCode ? (
						<div style={{ textAlign: "center", padding: "20px" }}>
							<Typography variant="h4" color="secondary" style={{ letterSpacing: "5px", fontWeight: "bold" }}>
								{pairCode}
							</Typography>
							<Typography variant="body2" color="textSecondary" style={{ marginTop: "10px" }}>
								{i18n.t("qrCode.pairCodeHelp")}
							</Typography>
						</div>
					) : (
						<span>Waiting for QR Code</span>
					)}
				</Paper>
			</DialogContent>
		</Dialog>
	);
};

export default React.memo(QrcodeModal);
